import { useDispatch, useSelector } from "react-redux";
import { saveAlertMessage } from "./screens/redux/slice/alertMessage";
import { TOKEN } from "./screens/redux/api/Constants";
import AlertPopUp from "./components/Common/AlertPopup/alertPopup";
import { Spinner } from "react-bootstrap";
import ReactRoutes from "./routes";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Main from "./screens/redux/slice/errorLogger";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const alertMessage = useSelector((state) => state.alertMessage);

  const togglePopup = () => {
    dispatch(saveAlertMessage(null));
  };

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let token = localStorage.getItem(TOKEN);
    if (!token) {
      navigate("/");
      return;
    }
  }, [])

  // const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="App">
      <ReactRoutes />
      {/* <Main/> */}
    </div>
  );
}

export default App;
